import { Component, OnInit, ElementRef, ChangeDetectorRef } from '@angular/core';
import { Router, Route, ActivatedRoute, ParamMap} from '@angular/router';
import { Observable } from 'rxjs';
import { Meta, Title } from "@angular/platform-browser";
import { CourseService }       from '../_services/course.service';
import storage from 'local-storage-fallback';
import {Globals}                            from '../../Globals';

@Component({
  selector: 'search-index',
  styleUrls: ['./index.component.css'],
  templateUrl: './index.component.html'
})

export class IndexComponent implements OnInit {
  posts;
  total;
  query;
  queryFilter;
  canSearch;
  sortBy;
  types;
  menuShow;
  constructor(private activatedRoute: ActivatedRoute, private router: Router, private courseService: CourseService,private meta: Meta,private title: Title, private globals: Globals){
  }
  
  ngOnInit() {
    this.title.setTitle('Feature');
    this.canSearch = true;
    this.total = 0;
    this.query = '';
    this.sortBy = [
        {'key': 'most_popular', 'text': "Most Popular"},
        {'key': 'most_relevant', 'text': "Most Relevant"},
        {'key': 'price_low_to_hight', 'text': "Lowest Price"},
        {'key': 'price_hight_to_low', 'text': "Hightest Price"},
        {'key': 'newest', 'text': "Newest"}
    ]
    this.types = [
        {'key': 'elearning', 'text': "Elearning"},
        {'key': 'podcast', 'text': "Podcasts"},
        {'key': 'exam_simulator', 'text': "Exam Simulator"},
        {'key': 'books', 'text': "E-books"}
    ]
    this.queryFilter = {
        sort: {'key': 'most_popular', 'text': "Most Popular"},
        keywords: '',
        types: '' 
    }
    this.activatedRoute.queryParams.subscribe(params => {
        this.queryFilter.keywords = params.keywords ? params.keywords : '';
        this.queryFilter.types = params.type ? params.type : '';
        this.search();
    });
  }
  search(){
    if(this.canSearch == false) return;
    this.canSearch = false;
    // this.posts = null;
    this.courseService.searchCourse(this.queryFilter).subscribe(result => {
      this.posts = result.data;
      this.canSearch = true;
    });
  }
  selectType(type){
    if(! this.canSearch) return;
    this.queryFilter.types = this.queryFilter.types.split(',');
    if(this.queryFilter.types.indexOf(type) == -1){
        this.queryFilter.types.push(type);
    }else{
        this.queryFilter.types.splice(this.queryFilter.types.indexOf(type), 1);
    }
    this.queryFilter.types = this.queryFilter.types.join(',');
    this.search();
  }
}
